export default theme => ({
    timeline: {
        position: 'relative',
        marginBottom: 36,
        padding: '50px 0 100px',
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            bottom: 0,
            width: '100vw',
            left: '50%',
            transform: 'translateX(-50vw)',
            backgroundColor: theme.palette.secondary.main,
        },
        '& .timeline-title': {
            fontSize: 40,
            letterSpacing: '0.056em',
            lineHeight: 1.2,
            color: theme.palette.secondary.contrastText,
            margin: '0 0 50px',
            textTransform: 'uppercase',
            fontWeight: 'bold',
            [theme.breakpoints.up('md')]: {
                fontSize: 56,
                margin: '0 auto 50px',
                textAlign: 'center',
                maxWidth: 768,
            }
        },
        '& .timeline-blurb, & .timeline-blurb *': {
            fontSize: 14,
            letterSpacing: '0.024em',
            lineHeight: 2,
            color: theme.palette.secondary.contrastText,
            margin: '0 0 30px',
            [theme.breakpoints.up('md')]: {
                fontSize: 16,
                letterSpacing: '0.032em',
                margin: '0 auto 50px',
                textAlign: 'center',
                maxWidth: 768,
            }
        },
        '& .start-dot, .end-dot': {
            borderRadius: '50%',
            border: '5px solid',
            borderColor: theme.palette.primary.main,
            width: 18,
            height: 18,
            margin: '-1px -7px',
            [theme.breakpoints.up('md')]: {
                width: 46,
                height: 46,
                margin: '-1px auto',
            }
        },
        '& *': {
            zIndex: 1,
            position: 'relative'
        },
        '& .timeline-inner:nth-of-type(even)': {
            '& .MuiGrid-container': {
                [theme.breakpoints.up('md')]: {
                    flexDirection: 'row-reverse',
                },
                '& h1, & h2, & h3, & h4, & h5, & h6': {
                    '&::before': {
                        [theme.breakpoints.up('md')]: {
                            left: -10,
                        },
                    }
                },
            }
        }
    },
    timelineTheme: {
        ...theme.timelineTheme,
    }
})